import React, { useEffect, useState } from "react";
import { Header, SideBar } from 'CommonComponent';

import './User.css';
import { UserList } from "./component";


const User = () => {

  return (
    <>
      <div className="wrapper-div">
        <h1 className="font-24 font-weight-s-bold mb-3 heading-color px-4 pt-4">All Users</h1>
          <UserList />
      </div>
    </>
  )
}

export default User
